import { render, staticRenderFns } from "./ElasticAiChatConversations.vue?vue&type=template&id=6bfebd44&scoped=true"
import script from "./ElasticAiChatConversations.vue?vue&type=script&setup=true&lang=js"
export * from "./ElasticAiChatConversations.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfebd44",
  null
  
)

export default component.exports